export type CtaSchedule = {
	start: string | null;
	end: string | null;
};

export const hasCtaSchedule = (schedule: CtaSchedule): boolean =>
	Boolean(schedule.start || schedule.end);

/** API/DB schedule values are UTC; naive strings must be parsed as UTC, not local. */
export const parseCtaScheduleDate = (value: string | null): Date | null => {
	if (!value) return null;
	const trimmed = value.trim();
	if (!trimmed) return null;

	const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(trimmed);
	const normalized = hasTimezone ? trimmed : `${trimmed}Z`;
	const date = new Date(normalized);
	return Number.isNaN(date.getTime()) ? null : date;
};

export const toDatetimeLocalValue = (iso: string | null): string => {
	const date = parseCtaScheduleDate(iso);
	if (!date) return '';

	const pad = (value: number) => String(value).padStart(2, '0');
	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
		+ `T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const fromDatetimeLocalValue = (value: string): string | null => {
	const trimmed = value.trim();
	if (!trimmed) return null;

	const date = new Date(trimmed);
	if (Number.isNaN(date.getTime())) return null;

	return date.toISOString();
};

export const isWithinCtaSchedule = (schedule: CtaSchedule, now = Date.now()): boolean => {
	if (!hasCtaSchedule(schedule)) return true;

	const start = parseCtaScheduleDate(schedule.start);
	if (start && now < start.getTime()) return false;

	const end = parseCtaScheduleDate(schedule.end);
	if (end && now > end.getTime()) return false;

	return true;
};

export const getEditorTimezoneLabel = (): string => {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone;
	} catch {
		return 'local time';
	}
};
